import { Vue, Component } from 'vue-property-decorator'
import { getRouterQuery } from '@utils/index'
import { split } from 'lodash'

@Component
export class SuperMixin extends Vue {
  get categoryId(): string | undefined {
    const selectedCategory = this.$route.query.selectedCategory
    return getRouterQuery(selectedCategory)
  }
  get categoryIds(): string[] | undefined {
    const queryCategoryIds: string | undefined = getRouterQuery(this.$route.query.categoryIds)
    return split(queryCategoryIds, ',')
  }
}
